export enum ExternalUrlQueryParamKeys {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum ExternalUrlQueryParamErrorValues {
  SESSION_EXPIRED = 'session-expired',
}
